export enum TravelerSteps {
  Traveler = 0,
  HealthScreening = 1,
  MedicalAssessment = 2
}
